import React, {
  useState,
  useMemo,
  useCallback,
} from "react";

import { useSelector } from "react-redux";

import Routes from "../Routes";

import CommonSidebar from "Common/CommonSidebar/CommonSidebar";
import CommonHeader from "Common/CommonHeader/CommonHeader";
import CommonBreadcrumb from "Common/CommonBreadcrumb/CommonBreadcrumb";

// =====================================================
// THEME SELECTOR
// =====================================================

const selectTheme = (() => {
  let prev = null;
  let prevValues = null;

  return (state) => {
    const values = [
      state.themeMode?.themeMode ||
        "light",

      state.theme?.themeColor ||
        "PurpleHeart",

      state.stroke?.borderStroke ||
        "svgstroke-a",

      state.boxLayout?.boxLayout ||
        "off",

      state.monochrome?.monochrome ||
        "off",

      state.borderRadius?.borderRadius ||
        "off",

      state.iconColor?.iconColor ||
        "off",

      state.gradientColor?.gradientColor ||
        "bg-gradient",
    ];

    const changed =
      !prevValues ||
      prevValues.some(
        (value, index) =>
          value !== values[index]
      );

    if (!changed) {
      return prev;
    }

    prevValues = values;

    prev = {
      themeMode: values[0],
      themeColor: values[1],
      borderStroke: values[2],
      boxLayout: values[3],
      monochrome: values[4],
      borderRadius: values[5],
      iconColor: values[6],
      gradientColor: values[7],
    };

    return prev;
  };
})();

// =====================================================
// ADMIN LAYOUT
// =====================================================

const AdminLayout = () => {
  const [
    sidebarHidden,
    setSidebarHidden,
  ] = useState(false);

  const theme =
    useSelector(selectTheme);

  const toggleSidebar =
    useCallback(() => {
      setSidebarHidden(
        (prev) => !prev
      );
    }, []);

  const layoutClasses =
    useMemo(() => {
      const containerClass =
        theme.boxLayout === "on"
          ? "container"
          : "container-fluid";

      const hotelHeadClass = [
        "Hotel_Head",

        theme.gradientColor,

        theme.borderStroke,

        sidebarHidden
          ? "sidebar-hide"
          : "",

        theme.boxLayout === "on"
          ? "box-layout rightbar-hide"
          : "",

        theme.monochrome === "on"
          ? "monochrome"
          : "",

        theme.borderRadius === "on"
          ? "radius-0"
          : "",
      ]
        .filter(Boolean)
        .join(" ");

      return {
        containerClass,
        hotelHeadClass,
      };
    }, [
      theme,
      sidebarHidden,
    ]);

  return (
    <div
      id="root-container"
      data-ha={`theme-${theme.themeColor}`}
      data-bs-theme={
        theme.themeMode
      }
      className={
        layoutClasses.hotelHeadClass
      }
    >
      <main
        className={`${layoutClasses.containerClass} px-0`}
      >
        <CommonSidebar
          iconColor={
            theme.iconColor === "on"
              ? "icon-color"
              : ""
          }
        />

        <div className="content">
          <CommonHeader
            toggleSidebar={
              toggleSidebar
            }
            sidebarHidden={
              sidebarHidden
            }
          />

          <CommonBreadcrumb />

          <Routes />
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;